import React from 'react'

const ModalContext = React.createContext<{
  openModal: (modal: string, passedData?: any) => void
  closeModal: (modal: string) => void
  modal
  modalData: any
}>({
  openModal: () => {},
  closeModal: () => {},
  modal: undefined,
  modalData: undefined
})

export default ModalContext
